import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import logo from "../logo.png";

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [sticky, setSticky] = useState(false);
  function Sticky() {
    if (window.scrollY > 40) {
      setSticky(true);
    } else {
      setSticky(false);
    }
  }

  const goToTop = () => {
    window.scrollTo({ top: 0, behaviour: "smooth" });
  };

  useEffect(() => {
    document.addEventListener("scroll", Sticky);
    return () => {
      document.removeEventListener("scroll", Sticky);
    };
  }, [sticky]);
  return (
    <>
      <nav className={sticky ? "navbar Sticky" : "navbar"}>
        <Banner />
        <div className="max-width">
          <div className="logo">
            <NavLink to="/" onClick={goToTop}>
              {" "}
              <img src={logo} alt={logo} /> Akshit Rana{" "}
            </NavLink>
          </div>
          <ul className={isMobile ? "menu active" : "menu"} id="nav-menu">
            <li>
              {" "}
              <a
                href="#home"
                className="nav-link"
                onClick={() => {
                  setIsMobile(!isMobile);
                }}
              >
                Home
              </a>{" "}
            </li>
            <li>
              {" "}
              <a
                href="#About"
                className="nav-link"
                onClick={() => {
                  setIsMobile(!isMobile);
                }}
              >
                About
              </a>
            </li>
            <li>
              {" "}
              <a
                href="#skills"
                className="nav-link"
                onClick={() => {
                  setIsMobile(!isMobile);
                }}
              >
                Skills
              </a>
            </li>
            <li>
              {" "}
              <a
                href="#projects"
                className="nav-link"
                onClick={() => {
                  setIsMobile(!isMobile);
                }}
              >
                Projects
              </a>
            </li>
            <li>
              {" "}
              <a
                href="#contact"
                className="nav-link"
                onClick={() => {
                  setIsMobile(!isMobile);
                }}
              >
                Contact{" "}
              </a>
            </li>
            <li>
              {" "}
              <a
                href="https://drive.google.com/file/d/112WoJRyY1PqtSZp42aX9yqo7rw1OAIQG/view?usp=sharing"
                className="nav-link"
                target="_open"
                onClick={() => {
                  setIsMobile(!isMobile);
                }}
              >
                Resume
              </a>
            </li>
          </ul>
          <div
            id="menu-btn"
            className={isMobile ? "menu-btn active" : "menu-btn"}
            onClick={() => {
              setIsMobile(!isMobile);
            }}
          >
            <div id="one" className="bar half start"></div>
            <div id="two" className="bar"></div>
            <div id="three" className="bar half end"></div>
          </div>
        </div>
      </nav>
    </>
  );
};

const Banner = () => {
  const [show, setShow] = useState(true);

  return (
    show && (
      <div className="nav-banner">
        <p>New portfolio is now live!</p>
        <a href="http://akshitr.com" target="_blank" rel="noopener noreferrer">
          Check it out <i className="fas fa-link"></i>
        </a>
        <button
          style={{
            position: "absolute",
            right: "14px",
            fontSize: "2rem",
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "#111",
          }}
        >
          <i className="fas fa-times" onClick={() => setShow(false)}></i>
        </button>
      </div>
    )
  );
};

export default Navbar;
